import {filtersSlice} from "./filtersSlice";

// Action to set filters
export const setFilters = (filters) => {
  const { setFilters } = filtersSlice.actions;

  return (dispatch) => {
    dispatch(setFilters(filters));
  };
};

// Action to reset filters to their initial state
export const resetFilters = () => {
  const { resetFilters } = filtersSlice.actions;

  return (dispatch) => {
    dispatch(resetFilters());
  };
};

// Action to update filters
export const updateFilters = (updatedFilters) => {
  const { updateFilters } = filtersSlice.actions;

  return (dispatch) => {
    dispatch(updateFilters(updatedFilters));
  };
};

// Action to delete filters
export const deleteFilters = (...keys) => {
  const { deleteFilters } = filtersSlice.actions;

  return (dispatch) => {
    const payload = {};
    keys.forEach((key) => {
      payload[key] = true; // Assign any value (e.g., true)
    });
    dispatch(deleteFilters(payload));
  };
};

export const updateAndDeleteFilters = (updates, deletes) => {
    const { updateAndDeleteFilters } = filtersSlice.actions;

    return (dispatch) => {
      dispatch(updateAndDeleteFilters({ updates, deletes }));
    };
  };
  
